import React from 'react';
import styled from 'styled-components';

import { p, pt, pb, px, py, mt, mb, mx } from 'styled-components-spacing';
import { map } from 'styled-components-breakpoint';
import { colors, Text, Heading } from 'themes/components';

import HighlightText from 'utils/HighlightText';
import SecurityIcon from './Icons/SecurityIcon';
import Button from './Button';
import Eyebrow from './Eyebrow';
import GlowBorder from './GlowBorder';

const Container = styled.div`
  ${py({ mobile: 5, desktop: 8, xl: 10 })};
  ${px(2)};
  max-width: 1280px;
  margin: 0 auto;
  position: relative;
  text-align: center;
`;

const TextContainer = styled.div`
  max-width: 600px;
  text-align: center;
  margin: 0 auto;
  ${mb({ mobile: 2, tablet: 4 })};
  ${mt({ mobile: 0, tablet: 4 })};
  color: ${colors.grey30};
`;

const Security = () => {
  return (
    <Container>
      <GlowBorder
        borderColor="hsla(165, 48%, 53%, 0.4)"
        glow2="hsla(197, 100%, 75%, 0.38)"
        glow1="hsla(279, 68%, 52%, 0.52)"
        glow3="hsla(302, 95%, 85%, 0.4)"
      />
      <Eyebrow
        bg1="hsla(165, 21%, 24%, 0.75)"
        bg2="hsla(265, 8%, 20%, 0.75)"
        border1="hsla(165, 100%, 69%, 0.35)"
        border2="hsla(265, 87%, 83%, 0.3)"
      >
        <SecurityIcon />
        <HighlightText
          direction="top left"
          stopOne={colors.purple30}
          stopTwo={colors.teal40}
        >
          Enterprise-grade security.
        </HighlightText>
      </Eyebrow>
      <TextContainer>
        <Heading
          variant="h2"
          style={{ marginBottom: '16px', color: colors.heading }}
        >
          Mudstack is built with security in mind,
          <br />
          <HighlightText
            direction="right"
            stopOne={colors.teal40}
            stopTwo={colors.purple30}
          >
            from the beginning.
          </HighlightText>
        </Heading>
        <Text variant="large">
          IP security is paramount to the concerns of every game studio. We've
          built Mudstack on a secure multi-tenant architecture, with a focus on
          access control, privacy and speed.
        </Text>
      </TextContainer>
      <Button
        as="a"
        href="https://docs.mudstack.com/security"
        target="_blank"
        secondary
      >
        Read more about our security &rarr;
      </Button>
    </Container>
  );
};

export default Security;
